module.exports = __webpack_public_path__ + "static/media/maxims_running.156b57c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/maxims_running.png
// module id = 680
// module chunks = 0